import { memo, useCallback } from 'react'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { Link, useNavigate } from 'react-router-dom'
import { TopMenu } from '../@types/aboutfishing'
import { getOrderList } from '../api/orderHistory'
import { RNPostMessage, AFWebLinkType, sendSetAppsflyerEvent } from '../js/postMessage'
import { getParsedSessionStorageItem, setPrevScroll } from '../js/script'
import { useCommonContext } from './provider/CommonProvider'
import { useAppContext } from '../components/provider/AppProvider'

interface HeaderTopMenuProps {
  homeMenu: TopMenu[]
  isFirstVisit: boolean
}

const HeaderTopMenu = ({ homeMenu, isFirstVisit }: HeaderTopMenuProps) => {
  const navigate = useNavigate()
  const { hasAccessToken } = useCommonContext()
  const { isAppView } = useAppContext()

  const appNavigationHandler = (el: TopMenu) => {
    const buildAppUrl = (target: string) => `aboutfishing://aboutfishing.com/?page=webview&url=${target}`

    const targetUrl = el.type === 'url' ? el.landingTarget : `${process.env.REACT_APP_SHOP_URL}${el.path}`

    RNPostMessage(AFWebLinkType.moveToLink, { url: buildAppUrl(targetUrl) })
  }

  const webNavigationHandler = (el: TopMenu) => {
    if (el.type === 'url') {
      window.location.href = el.landingTarget // 외부 URL은 그대로 처리
    } else {
      navigate(el.path) // 내부 경로는 navigate로 처리
    }
  }

  const gtmHandler = (el: TopMenu) => {
    const gtmNavigateClick: DataLayerArgs = {
      dataLayer: {
        event: 'click_navigation',
        event_info: {
          click_location: 'top',
          click_label: el.title,
        },
      },
    }

    if (isAppView) {
      sendSetAppsflyerEvent({
        eventName: 'click_navigation',
        eventType: {
          click_location: 'top',
          click_label: el.title,
        },
      })
    } else {
      TagManager.dataLayer(gtmNavigateClick)
    }
  }

  const checkUseOneHundredShop = async (el: TopMenu) => {
    const res = await getOrderList()
    if (res.data.items.length !== 0) {
      alert('첫 구매가 아니시네요. 아쉽지만 이용하실 수 없습니다.')
      return
    }

    const parseData = getParsedSessionStorageItem('parseData')
    if (parseData?.shopifyUserOrder) {
      alert('첫 구매가 아니시네요. 아쉽지만 이용하실 수 없습니다.')
      return
    }

    if (!hasAccessToken) {
      alert('회원가입 시 구매하실 수 있습니다.')
      return
    }
  }

  const handleClick = useCallback(
    async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, el: TopMenu) => {
      e.preventDefault()
      // GTM 함수 실행
      gtmHandler(el)

      // 100원 샵 이용 가능 체크
      if (el.title === '100원샵') await checkUseOneHundredShop(el)

      if (isAppView) appNavigationHandler(el)
      else webNavigationHandler(el)

      // setPrevScroll(document.documentElement.scrollTop);
    },
    [isAppView, hasAccessToken, navigate, setPrevScroll]
  )

  return (
    <div className='top_category'>
      <ul>
        <li className='home'>홈</li>
        {homeMenu
          .filter((el) => !(el.title === '100원샵' && isFirstVisit))
          .map((el: TopMenu) => (
            <li key={el.title || el.path}>
              <Link to={el.type === 'url' ? el.landingTarget : el.path} onClick={(e) => handleClick(e, el)}>
                {el.title}
              </Link>
            </li>
          ))}
      </ul>
    </div>
  )
}

export default memo(HeaderTopMenu)
